import { Component, OnInit, Output, EventEmitter,ViewChild  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { ToastComponent } from "../../layout/toast/toast.component";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sudgame',
  templateUrl: './sudgame.component.html',
  styleUrls: ['./sudgame.component.css']
})

export class SudgameComponent implements OnInit {
    @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;
    constructor(
        public httpClient: HttpClient,
    ){}

    ngOnInit(): void {
        this.init_list();
    }
    loading:boolean=true;
    data:any=[];
    data1:any=[];
    Tmpdata:any=[];
    TmpdataID:any=0;
    edit_data:any=[];
    sort_obj:any = {column:'create_dt',sort:'0'}
    sort_obj1:any = {column:'create_dt',sort:'0'}
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));
    pageobj1:page = {page:0,count:10,total_count:0};
    pageobjstr1:string=JSON.parse(JSON.stringify(this.pageobj1));
    sudgame_type = '-2';
    menu_type = '0';
    status_type = '-2';
    search_model: string = '';
    date_filter: any = { start: '', end: '' };
    date_timeset: any = { start: '', end: '' };

    sudgame_list:menulist = [
        {id:'3',name:'不限'},
        {id:'1',name:'語音'},
        {id:'2',name:'視訊'},
    ];

    status_list:menulist = [
        {id:'0',name:'停用'},
        {id:'1',name:'啟用'},
    ];

    menu_list:menulist = [
        {id:'0',name:'遊戲列表'},
        {id:'1',name:'遊玩清單'},
    ];

    tcontent:any = [
        {title:'遊戲名',content:'name'},
        {title:'類型',content:'type',type:3},
        {title:'Icon',content:'icon',type:1},
        {title:'遊戲ID',content:'mg_id'},
        {title:'入場費',content:'diamond'},
        {title:'收益',content:'battle_diamond'},
        {title:'時長',content:'duration',type:3},
        {title:'人數',content:'user_num'},
        {title:'筆數',content:'battle_count'},
        {title:'狀態',content:'status',type:3},
        {title:'建立時間',content:'create_dt'},
        {title:'更新時間',content:'update_dt'},
        {title:'操作',content:'gg',type:3},
    ];

    tcontent1:any = [
        {title:'發起者',content:'from_user_name'},
        {title:'該局時長',content:'duration',type:3},
        {title:'入場費',content:'diamond'},
        {title:'開始時間',content:'start_time'},
        {title:'結束時間',content:'end_time'},
        {title:'人數',content:'user_num'},
        {title:'贏家',content:'winner_name'},
        {title:'詳細資料',content:'gg',type:3},
    ];

    tcontent2:any = [
        {title:'用戶',content:'user_name'},
        {title:'分數',content:'score'},
        {title:'入場費',content:'diamond'},
        {title:'鑽石消費',content:'consume'},
    ];

    typeMap = new Map<number | string, string>([
        ['1', '語音'],
        ['2', '視訊'],
        ['3', '不限'],
    ]);

    open = false;

    choose(id: string) {
        this.menu_type = id;
        this.default_page(); // 重置頁面並加載數據
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    callback1(pageobj:page){
        if(JSON.stringify(this.pageobj1)!=JSON.stringify(pageobj)){
            this.pageobj1 = pageobj;
            this.detail_list();
        }
    }

    open_detail(id){
        this.TmpdataID = id;
        this.detail_list();
    }

    detail_list(){
        this.loading = true;
        const body = {
            page: this.pageobj1.page,
            count:this.pageobj1.count,
            sort_obj:this.sort_obj1,
            id:this.TmpdataID,
            detail:1
        };
        this.httpClient.post<any>("/setting/get_sudgame.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.data1 = res.data;
                this.pageobj1.total_count = res.total_count;
                this.pageobjstr1=JSON.parse(JSON.stringify(this.pageobj1));
            }else{
                this.data1 = [];
            }

        });
    }



    init_list(){
        this.loading = true;
        const body = {
            page: this.pageobj.page,
            count: this.pageobj.count,
            sort_obj: this.sort_obj,
            sudgame_type: this.sudgame_type,
            status_type: this.status_type,
            menu_type: this.menu_type,
            search_model: this.search_model,
            date_filter: this.date_filter,
            open:this.open
        };
        this.httpClient.post<any>("/setting/get_sudgame.php",body).subscribe(res => {
            this.loading = false;
            console.log('load',res);
            if(res.status){
                this.data = res.data;
                this.pageobj.total_count = res.total_count;
                this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
            }else{
                this.data = [];
            }

        });
    }

    default_page(){
        this.pageobj = {page:0,count:10,total_count:0};
        this.init_list();
    }


    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    save(){
        this.loading = true;
        const body = {
            data:this.Tmpdata,
        };
        this.httpClient.post<any>("/setting/set_sudgame.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                Swal.fire("修改完成!", "", "success");
            }else{
                Swal.fire("喔喔 出問題了!", "", "error");
            }
            //資料還原
            this.Tmpdata = [];
            this.init_list();
        });
    }

    handleDateRangeSelected(event: any) {
        if (event && event.event) {
            if (event.event.startDate || event.event.endDate) {
                        console.log('event',event);

                this.date_filter = event;
                this.default_page();
            }
        }
    }

    open_crtol(){
       this.open = true;
       this.default_page();
    }

    ShowDatePickered(){
        this.open = false;
        this.default_page();
    }

    formatDuration(duration: any): string {
        // 如果是字符串且已經是 HH:MM:SS 格式，直接返回
        if (typeof duration === 'string' && /^\d{2}:\d{2}:\d{2}$/.test(duration)) {
            return duration;
        }

        // 如果是數字（秒數），轉換為 HH:MM:SS 格式
        if (typeof duration === 'number' || !isNaN(Number(duration))) {
            const seconds = Number(duration);
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = Math.floor(seconds % 60);

            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
        }

        // 其他情況返回默認值
        return '00:00:00';
    }

}
